import React, { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import { useLocation, useNavigate } from "react-router-dom";
import { AddButton } from "../../utils/commonComponent/Custom/Button";
import { submitSiteDelete } from "./../../utils/commonComponent/delete";
import { fetchQuery } from "./../../utils/commonComponent/fetched";
import ListSearchSection from "../../utils/commonComponent/Custom/ListSearchSection";
import ListView from "../../utils/commonComponent/Custom/listView";
import {
  Discipline,
  DisciplineOptions,
} from "../disciplineMaster/disiplineConst";
import { getPermissions } from "../rbac/hasAccess";
import { calType } from "./testConstant";

const headers = ["id", "disciplineName", "groupName", "MaterialName"];

const fields = [
  { value: "discplineId", label: "Discipline Name" },
  { value: "groupName", label: "Group Name" },
  { value: "MaterialName", label: "Material Name" },
];

const TestMasterList = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const permissions = getPermissions(props.moduleId);
  const handleEdit = (row) => navigate(`/master/editTestMaster/${row.id}`);
  const handleDelete = (row) => submitSiteDelete("materialScope", row.id);

  const [testList, setTestList] = useState([]);
  const [allTestMasterData, setAllTestMasterData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [searchBy, setSearchBy] = React.useState(sessionStorage.getItem("searchBy") || "MaterialName");
   const [searchKey, setSearchKey] = React.useState(sessionStorage.getItem("searchKey") || "");
   const [searched, setSearched] = React.useState(sessionStorage.getItem("searched") === "true" || false);
    // Pagination
   const [currentPage, setCurrentPage] = useState(() => Number(sessionStorage.getItem("ListPageCount") || 0));
   const [rowsPerPage, setRowsPerPage] = useState(() => Number(sessionStorage.getItem("ListRowsPerPage") || 30));

  const handlePaginationChange = (page, rows) => {
    setCurrentPage(page);
    setRowsPerPage(rows);
    // fetch new data from backend here
  };

  const getWhereClause = () => {
    const colMap = {
      MaterialName: "ms.MaterialName",
      groupName: "g.groupName",
      discplineId: "ms.discplineId",
    };

    const colName = colMap[searchBy];
    const key = searchKey.trim();

    let whereConditions = ["ms.status = 1"];

    if (colName && key) {
      if (colName === "ms.discplineId") {
        const matches = DisciplineOptions.filter((opt) =>
          opt.label.toLowerCase().includes(key.toLowerCase())
        ).map((opt) => `${colName} = ${opt.id}`);

        if (matches.length) {
          whereConditions.push(`(${matches.join(" OR ")})`);
        }
      } else {
        whereConditions.push(`LOWER(${colName}) LIKE '%${key.toLowerCase()}%'`);
      }
    }

    return whereConditions.length
      ? `WHERE ${whereConditions.join(" AND ")}`
      : "";
  };

  const getDataQuery = () => {
    const whereClause = getWhereClause();

    let paginationSettings = "";
    if (rowsPerPage !== -1) {
      paginationSettings = `LIMIT ${rowsPerPage} OFFSET ${rowsPerPage * Number(currentPage)
        }`;
    }

    return `SELECT ms.*, g.groupName AS groupName FROM materialScope ms LEFT JOIN discipline g ON g.id = ms.groupId ${whereClause} ORDER BY ms.id DESC ${paginationSettings};`;
  };

  const getCountQuery = () => {
    const whereClause = getWhereClause();

    return `
    SELECT COUNT(DISTINCT ms.id) AS totalRows
    FROM materialScope ms
    LEFT JOIN discipline g ON g.id = ms.groupId
    ${whereClause};
  `;
  };

  const fetchData = async () => {
    try {
      const [testData, countResult] = await Promise.all([
        fetchQuery(getDataQuery()),
        fetchQuery(getCountQuery()),
      ]);

      const formattedData = testData.map((item) => ({
        ...item,
        disciplineName:
          DisciplineOptions.find((key) => key.id == item.discplineId)?.label ||
          "",
      }));

      setTestList(formattedData);
      setTotalRows(countResult?.[0]?.totalRows || 0); // 👈 pagination state
    } catch (error) {
      console.error("Error fetching test data:", error);
    }
  };

  const handleSearch = () => {
    if (!searchBy || !searchKey.trim()) {
      alert("Please select a search field and enter a search value.");
      return;
    }
    fetchData();
    setSearched(true);
    // Save search state to sessionStorage
    sessionStorage.setItem("searchBy", searchBy);
    sessionStorage.setItem("searchKey", searchKey);
    sessionStorage.setItem("searched", "true");
    sessionStorage.setItem("currentPath", location.pathname);
    sessionStorage.setItem("ListPageCount", 0);
    setCurrentPage(0);
  };

  const clearSearch = () => {
    setSearched(false);
    setSearchBy("MaterialName");
    setSearchKey("");
     // Clear all employee list session storage
    sessionStorage.removeItem("ListPageCount");
    sessionStorage.removeItem("ListRowsPerPage");
    sessionStorage.removeItem("searchBy");
    sessionStorage.removeItem("searchKey");
    sessionStorage.removeItem("searched");
    setCurrentPage(0);
  };

  const fetchAllTestMasterData = async () => {
    try {
      const conditionQuery = `SELECT ms.*, g.groupName AS groupName, mt.* FROM materialScope ms LEFT JOIN discipline g ON g.id = ms.groupId LEFT JOIN materialTestings mt ON mt.materialId = ms.id WHERE ms.status = 1 ORDER BY ms.id DESC`;
      const testMasterData = await fetchQuery(conditionQuery);

      const rowsWithDiscipline = testMasterData?.map((row) => ({
        disciplineName: Discipline?.find((d) => d.id == row.discplineId)?.label,
        ...row,
        scopeType: calType?.find((d) => d.id == row.scopeType)?.label,
      }));

      setAllTestMasterData(rowsWithDiscipline);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  useEffect(() => {
    fetchAllTestMasterData();
  }, []);

  useEffect(() => {
    fetchData();
  }, [currentPage, rowsPerPage]);

  useEffect(() => {
    if (searched == false) {
      fetchData();
    }
  }, [searched]);

  return (
    <>
      {(permissions.create || permissions.allAccess) && (
        <AddButton
          id="btn-add-outline"
          to="/master/editTestMaster/0"
          label="Add Accreditation Scope"
          icon={<AddIcon fontSize="small" />}
        />
      )}
      <ListSearchSection
        title="Search Accreditation Scope"
        fields={fields}
        onSearch={handleSearch}
        searchKey={searchKey}
        setSearchKey={setSearchKey}
        searchBy={searchBy}
        setSearchBy={setSearchBy}
        clearSearch={clearSearch}
        searched={searched}
        setSearched={setSearched}
        showExcelDownload={true}
        finalData={allTestMasterData}
        notNeededColumn={[
          "id",
          "discplineId",
          "groupId",
          "status",
          "materialId",
          "masterEquipmentId",
          "Status",
        ]}
      />

      <ListView
        headers={headers}
        data={testList}
        actions={{
          edit: handleEdit,
          delete: handleDelete,
        }}
        showCheckbox={true}
        deleteTableName={"materialScope"}
        moduleId={props.moduleId}
        currentPage={currentPage}
        rowsPerPage={rowsPerPage}
        totalRows={totalRows}
        onPaginationChange={handlePaginationChange}
      />
    </>
  );
};

export default TestMasterList;
